import { IAccentColors } from "config/types";

const styles = {
  drawer: (isConfirmModalOpen: boolean) => ({
    "&.MuiDrawer-root": {
      zIndex: isConfirmModalOpen ? 1600 : 1700,
    },
    "& .MuiPaper-root": {
      width: {
        xs: "100%",
        md: "80%",
        lg: "60%",
      },
    },
  }),
  drawerContent: {
    p: "20px",
    height: "100%",
  },
  closeIcon: {
    "&.MuiButtonBase-root.MuiIconButton-root": {
      position: "absolute",
      right: "10px",
      top: "10px",
      p: 0,
      "&:hover": {
        backgroundColor: "unset",
      },
    },
  },
  tabs: (accentColor: IAccentColors) => ({
    "& .MuiButtonBase-root.MuiTab-root": {
      color: "gray.main",
    },
    "& .MuiButtonBase-root.MuiTab-root.Mui-selected": {
      color: accentColor.main || "accents.main",
    },
    "& .MuiTabs-indicator": {
      bgcolor: accentColor.main || "accents.main",
    },
  }),
  btn: {
    mt: "20px",
    maxWidth: "230px",
    height: "36px",
  },
};

export default styles;
